import {
  PublicTemplate,
  SectorItem,
  PublicPricingPlan,
  FaqItem,
  Testimonial,
} from '../types/publicTypes';

export const PUBLIC_TEMPLATES: PublicTemplate[] = [
  {
    id: 'tpl-corp-apex',
    name: 'Apex Executive',
    slug: 'apex-executive',
    category: 'CORPORATE',
    categoryName: 'Kurumsal & Holding',
    description: 'Büyük ölçekli şirketler, holdingler ve danışmanlık firmaları için yüksek prestijli, keskin hatlı kurumsal şablon.',
    thumbnail: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop',
    rating: 4.9,
    reviewsCount: 142,
    popular: true,
    features: ['Hizmet Vitrini', 'Yönetim Kurulu & Ekip', 'Finansal Raporlar', 'Kurumsal Blog', 'İletişim & Teklif'],
    pages: ['Ana Sayfa', 'Kurumsal', 'Hizmetlerimiz', 'Projeler', 'Haberler', 'İletişim'],
    colors: {
      primary: '#0f172a',
      secondary: '#1e293b',
      accent: '#2563eb',
    },
  },
  {
    id: 'tpl-yacht-azure',
    name: 'Azure Majesty VIP',
    slug: 'azure-majesty-vip',
    category: 'YACHT_RENTAL',
    categoryName: 'Yat Kiralama & Mavi Tur',
    description: 'Motoryat, gulet ve süperyat kiralama acenteleri için dinamik rezervasyon motoru ve interaktif filo kataloğu.',
    thumbnail: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=1600&auto=format&fit=crop',
    rating: 5.0,
    reviewsCount: 98,
    popular: true,
    isNew: true,
    features: ['Dinamik Filo Kataloğu', 'Rezervasyon & Fiyat Hesaplama', 'Kabin & Boy Filtresi', 'Mavi Tur Rotaları', 'WhatsApp Hızlı Talep'],
    pages: ['Ana Sayfa', 'Yat Filosu', 'Mavi Tur Rotaları', 'Hizmetler', 'Rezervasyon', 'İletişim'],
    colors: {
      primary: '#0369a1',
      secondary: '#0c4a6e',
      accent: '#0284c7',
    },
  },
  {
    id: 'tpl-legal-justicia',
    name: 'Justicia Law & Partners',
    slug: 'justicia-law',
    category: 'LEGAL',
    categoryName: 'Hukuk & Avukatlık',
    description: 'Hukuk büroları, arabulucular ve danışmanlar için güven veren, tipografik zarafete sahip profesyonel tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1600&auto=format&fit=crop',
    rating: 4.8,
    reviewsCount: 76,
    features: ['Uzmanlık Alanları', 'Avukat Kadrosu', 'Hukuki Makaleler & İçtihat', 'Randevu Talep Formu', 'Müvekkil Yorumları'],
    pages: ['Ana Sayfa', 'Hakkımızda', 'Uzmanlıklar', 'Ekibimiz', 'Yayınlar', 'İletişim'],
    colors: {
      primary: '#18181b',
      secondary: '#27272a',
      accent: '#d97706',
    },
  },
  {
    id: 'tpl-health-sanavita',
    name: 'SanaVita Medical Clinic',
    slug: 'sanavita-medical',
    category: 'HEALTH',
    categoryName: 'Sağlık & Estetik Klinik',
    description: 'Özel klinikler, diş hekimleri, estetik cerrahi ve sağlık merkezleri için steril, güvenilir ve modern web sitesi.',
    thumbnail: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=1600&auto=format&fit=crop',
    rating: 4.9,
    reviewsCount: 115,
    popular: true,
    features: ['Tedaviler & Hizmetler', 'Doktor Kadrosu', 'Online Randevu Talebi', 'Öncesi & Sonrası Galerisi', 'Hasta Rehberi'],
    pages: ['Ana Sayfa', 'Klinik Hakkında', 'Tedaviler', 'Hekimlerimiz', 'Randevu Al', 'İletişim'],
    colors: {
      primary: '#0f766e',
      secondary: '#134e4a',
      accent: '#0d9488',
    },
  },
  {
    id: 'tpl-arch-studio',
    name: 'ArchForm Architecture',
    slug: 'archform-architecture',
    category: 'ARCHITECTURE',
    categoryName: 'Mimarlık & İnşaat',
    description: 'Mimarlık ofisleri, iç mimarlar ve gayrimenkul projeleri için büyük görsel odaklı, minimal ve ödüllü estetik.',
    thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop',
    rating: 4.9,
    reviewsCount: 89,
    features: ['Proje Portfolyosu (Grid/Masonry)', '3D Render & Plan Galerisi', 'Mimari Konseptler', 'Ödüller & Basın', 'Proje Başlat Formu'],
    pages: ['Ana Sayfa', 'Projeler', 'Stüdyo', 'Ödüller', 'İletişim'],
    colors: {
      primary: '#171717',
      secondary: '#262626',
      accent: '#e11d48',
    },
  },
  {
    id: 'tpl-gastro-lumina',
    name: 'Lumina Fine Dining',
    slug: 'lumina-dining',
    category: 'GASTRONOMY',
    categoryName: 'Restoran & Gastronomi',
    description: 'Fine dining restoranlar, butik cafeler ve şef mutfakları için dijital menü ve online masa rezervasyonlu şablon.',
    thumbnail: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1600&auto=format&fit=crop',
    rating: 4.8,
    reviewsCount: 64,
    features: ['İnteraktif Dijital Menü', 'Masa Rezervasyon Sistemi', 'Şefin Spesiyalleri', 'Özel Etkinlik Talebi', 'Konum & Çalışma Saatleri'],
    pages: ['Ana Sayfa', 'Menümüz', 'Hikayemiz', 'Şefler', 'Rezervasyon', 'İletişim'],
    colors: {
      primary: '#451a03',
      secondary: '#78350f',
      accent: '#d97706',
    },
  },
  {
    id: 'tpl-corp-vertex',
    name: 'Vertex Tech & Finans',
    slug: 'vertex-tech-finans',
    category: 'CORPORATE',
    categoryName: 'Kurumsal & Holding',
    description: 'Teknoloji şirketleri, SaaS girişimleri ve yatırım fonları için modern karanlık & aydınlık mod destekli kurumsal arayüz.',
    thumbnail: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1600&auto=format&fit=crop',
    rating: 4.9,
    reviewsCount: 104,
    features: ['Ürün & Hizmet Ağacı', 'Metrik & İstatistik Sayaçları', 'Yatırımcı İlişkileri', 'Vaka Analizleri (Case Studies)', 'Demo Talep Formu'],
    pages: ['Ana Sayfa', 'Çözümler', 'Yatırımlar', 'Hakkımızda', 'Kariyer', 'İletişim'],
    colors: {
      primary: '#09090b',
      secondary: '#18181b',
      accent: '#6366f1',
    },
  },
  {
    id: 'tpl-yacht-poseidon',
    name: 'Poseidon Gulet Charter',
    slug: 'poseidon-gulet-charter',
    category: 'YACHT_RENTAL',
    categoryName: 'Yat Kiralama & Mavi Tur',
    description: 'Ahşap lüks guletler ve mavi yolculuk acenteleri için Ege & Akdeniz temalı sıcak ve prestijli kiralama platformu.',
    thumbnail: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=800&auto=format&fit=crop',
    fullPreviewImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1600&auto=format&fit=crop',
    rating: 4.9,
    reviewsCount: 52,
    features: ['Gulet Filosu Listeleme', 'Kabin Seçenekleri & Kat Planı', 'Haftalık Fiyat Tablosu', 'Özel Aşçı & Menü Seçimi', 'Erken Rezervasyon Modülü'],
    pages: ['Ana Sayfa', 'Guletlerimiz', 'Mavi Yolculuk', 'Koylar', 'Fiyatlar', 'Rezervasyon'],
    colors: {
      primary: '#1e3a8a',
      secondary: '#172554',
      accent: '#38bdf8',
    },
  },
];

export const PUBLIC_SECTORS: SectorItem[] = [
  {
    id: 'CORPORATE',
    name: 'Kurumsal & Holdingler',
    tagline: 'Kurumsal prestijinizi ve güvenilirliğinizi dijitalde en üst seviyeye taşıyın.',
    description: 'Danışmanlık firmaları, holdingler, finans kuruluşları ve KOBİ’ler için özel olarak kurgulanmış; hizmet vitrinleri, vaka çalışmaları, kurumsal blog ve teklif formu içeren tam kapsamlı altyapı.',
    icon: 'Building2',
    heroImage: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'En Çok Tercih Edilen',
    recommendedTemplateId: 'tpl-corp-apex',
    stats: { label: 'Yayındaki Kurumsal Site', value: '1.200+' },
    keyFeatures: [
      'Gelişmiş kurumsal hizmet ve ürün katalogları',
      'Yönetim kurulu, lider kadro ve ekip tanıtım blokları',
      'Müşteri referansları, sertifikalar ve başarı sayaçları',
      'Kurumsal haber bülteni ve SEO uyumlu blog motoru',
      'Özelleştirilebilir kurumsal teklif ve iletişim formları',
    ],
    includedModules: ['Hizmet Kataloğu', 'Blog & Haberler', 'Özel Domain + SSL', 'İletişim CRM', 'SEO Optimizatörü'],
  },
  {
    id: 'YACHT_RENTAL',
    name: 'Lüks Yat Kiralama & Mavi Tur',
    tagline: 'Filo yönetimi ve doğrudan müşteri rezervasyon motoru bir arada.',
    description: 'Yat kiralama acenteleri, tekne sahipleri ve mavi yolculuk operatörleri için geliştirilmiş; motoryat, gulet ve katamaranlarınızı teknik detayları, kabin kapasiteleri ve haftalık fiyatlarıyla listeleyen anahtar teslim çözüm.',
    icon: 'Anchor',
    heroImage: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'Sektöre Özel Entegre Motor',
    recommendedTemplateId: 'tpl-yacht-azure',
    stats: { label: 'Listelenen Lüks Yat', value: '450+' },
    keyFeatures: [
      'Dinamik yat filosu yönetimi (kabin, boy, motor, liman, mürettebat)',
      'Gelişmiş müşteri rezervasyon ve teklif talep motoru',
      'Müsaitlik ve doluluk takvimi entegrasyonu',
      'Para birimi seçimi (EUR, USD, TRY) ve haftalık/günlük tarife',
      'WhatsApp ve tek tıkla doğrudan arama entegrasyonu',
    ],
    includedModules: ['Yat Filosu Modülü', 'Rezervasyon Motoru', 'Müsaitlik Takvimi', 'Rota Rehberleri', 'WhatsApp Satış'],
  },
  {
    id: 'LEGAL',
    name: 'Hukuk Büroları & Avukatlık',
    tagline: 'Güven, ciddiyet ve hukuki uzmanlığınızı yansıtan kusursuz web siteleri.',
    description: 'Avukatlar, arabulucular ve hukuk danışmanlık ortaklıkları için TBB meslek kurallarına ve kurumsal ciddiyete tam uyumlu, makale yayınlama ve danışmanlık talep altyapısı.',
    icon: 'Scale',
    heroImage: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'Prestij & Güven',
    recommendedTemplateId: 'tpl-legal-justicia',
    stats: { label: 'Aktif Hukuk Bürosu', value: '380+' },
    keyFeatures: [
      'Uzmanlık alanları ve dava konusu sınıflandırmaları',
      'Avukat ve akademisyen kadrosu biyografi sayfaları',
      'Mevzuat analizleri ve hukuki bülten modülü',
      'KVKK aydınlatma metni ve gizlilik altyapısı',
      'Online danışmanlık randevu talep sistemi',
    ],
    includedModules: ['Uzmanlık Alanları', 'Hukuki Makaleler', 'Ekip Profilleri', 'KVKK Uyumlu Formlar'],
  },
  {
    id: 'HEALTH',
    name: 'Sağlık & Estetik Klinikler',
    tagline: 'Hasta güvenini artıran steril, modern ve bilgilendirici klinik siteleri.',
    description: 'Diş klinikleri, estetik merkezleri, fizik tedavi üniteleri ve uzman doktor muayenehaneleri için tedavi rehberleri ve online randevu talep formu sunan sektörel sistem.',
    icon: 'Stethoscope',
    heroImage: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'Hasta Odaklı Arayüz',
    recommendedTemplateId: 'tpl-health-sanavita',
    stats: { label: 'Hizmet Veren Klinik', value: '520+' },
    keyFeatures: [
      'Detaylı tedavi sayfaları ve sıkça sorulan sorular',
      'Uzman hekim ve sağlık personeli tanıtımları',
      'Hasta kabul ve online randevu talep mekanizması',
      'Sağlık turizmi için çoklu dil hazır altyapı',
      'Steril ve yüksek çözünürlüklü klinik fotoğraf galerileri',
    ],
    includedModules: ['Tedavi Kataloğu', 'Online Randevu', 'Hekim Kadrosu', 'Çoklu Dil Desteği'],
  },
  {
    id: 'ARCHITECTURE',
    name: 'Mimarlık & İnşaat Projeleri',
    tagline: 'Projelerinizi büyüleyici görsel portfolyolarla sunun.',
    description: 'İç mimarlar, mimarlık ofisleri, müteahhitlik ve gayrimenkul geliştirme firmaları için ödüllü tasarım diline sahip portfolyo ve proje sunum altyapısı.',
    icon: 'Compass',
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'Görsel Başyapıt',
    recommendedTemplateId: 'tpl-arch-studio',
    stats: { label: 'Yayınlanan Mimari Proje', value: '2.400+' },
    keyFeatures: [
      'Geniş ekran HD proje galerileri ve render sunumları',
      'Tamamlanan, devam eden ve konsept proje filtreleri',
      'Kat planları ve teknik özellik tabloları',
      'Basında biz, yayınlar ve tasarım ödülleri vitrini',
      'Potansiyel müşteriler için proje brifing formu',
    ],
    includedModules: ['Proje Portfolyosu', 'HD Medya Galerisi', 'Plan Görüntüleyici', 'Brifing Formu'],
  },
  {
    id: 'GASTRONOMY',
    name: 'Restoran, Cafe & Gastronomi',
    tagline: 'Lezzetinizi dijital menü ve online masa rezervasyonuyla buluşturun.',
    description: 'Fine dining restoranlar, butik cafeler, sahil kulüpleri ve catering firmaları için QR kod uyumlu dijital menü, şef spesiyalleri ve masa rezervasyon motoru.',
    icon: 'Utensils',
    heroImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1200&auto=format&fit=crop',
    badgeText: 'Rezervasyon & Menü',
    recommendedTemplateId: 'tpl-gastro-lumina',
    stats: { label: 'Aktif Restoran Menüsü', value: '710+' },
    keyFeatures: [
      'Kategorize edilmiş interaktif yemek & içecek menüsü',
      'Alerjen, kalori ve şef tavsiyesi etiketleri',
      'Masa rezervasyon ve özel etkinlik talep sistemi',
      'Mobil cihazlar için optimize edilmiş QR menü görünümü',
      'Konum, yol tarifi ve çalışma saatleri entegrasyonu',
    ],
    includedModules: ['Dijital Menü', 'Masa Rezervasyonu', 'QR Entegrasyonu', 'Etkinlik Formu'],
  },
];

export const PUBLIC_PRICING_PLANS: PublicPricingPlan[] = [
  {
    id: 'corp-starter',
    name: 'Kurumsal Başlangıç',
    tagline: 'Küçük işletmeler ve profesyoneller için temel kurumsal web sitesi.',
    monthlyPriceTRY: 1750,
    annualPriceTRY: 14000,
    targetAudience: 'Serbest çalışanlar, avukatlar ve yerel işletmeler',
    ctaText: 'Başlangıç Paketini Seç',
    ctaAction: '/kayit',
    features: [
      { text: 'Görsel Sürükle & Bırak Web Sitesi Editörü', included: true },
      { text: '3 Adet Kurumsal Sektörel Tema Seçeneği', included: true },
      { text: 'Özel Alan Adı Bağlama (.com, .com.tr)', included: true },
      { text: 'Ücretsiz 256-Bit SSL Güvenlik Sertifikası', included: true },
      { text: '5 GB Yüksek Hızlı Bulut Depolama', included: true },
      { text: 'Temel SEO ve Google İndeksleme Araçları', included: true },
      { text: 'İletişim & Teklif Toplama Formları', included: true },
      { text: 'Lüks Yat & Gelişmiş Rezervasyon Motoru', included: false },
      { text: 'Öncelikli 7/24 VIP Destek Hattı', included: false },
    ],
  },
  {
    id: 'corp-pro',
    name: 'Kurumsal Pro & Büyüme',
    tagline: 'Holdingler, danışmanlık şirketleri ve büyüyen markalar için tam paket.',
    monthlyPriceTRY: 2200,
    annualPriceTRY: 18000,
    popular: true,
    badge: 'En Çok Tercih Edilen',
    targetAudience: 'Kurumsal firmalar, klinikler ve mimarlık ofisleri',
    ctaText: 'Hemen 14 Gün Ücretsiz Başla',
    ctaAction: '/kayit',
    features: [
      { text: 'Tüm Kurumsal Şablonlara Sınırsız Erişim (5+ Tema)', included: true, highlight: true },
      { text: 'Sınırsız Sayfa ve Dinamik Menü Yönetimi', included: true },
      { text: 'Kurumsal Blog, Haber ve İçerik Pazarlama Modülü', included: true },
      { text: 'Özel Alan Adı + Otomatik DNS Doğrulama', included: true },
      { text: '15 GB Yüksek Çözünürlüklü Medya Depolama', included: true },
      { text: 'Gelişmiş SEO Analizi, OpenGraph & Otomatik Sitemap', included: true, highlight: true },
      { text: 'Çoklu Kullanıcı ve Departman Yetkilendirme', included: true },
      { text: 'Google Analytics & Meta Pixel Entegrasyonu', included: true },
      { text: 'Öncelikli E-posta ve Canlı Destek', included: true },
    ],
  },
  {
    id: 'yacht-luxury',
    name: 'Lüks Yat Kiralama & Rezervasyon',
    tagline: 'Yat acenteleri ve tekne sahipleri için sektöre özel rezervasyon motoru.',
    monthlyPriceTRY: 4200,
    annualPriceTRY: 36000,
    badge: 'Yatçılık Özel Paketi',
    targetAudience: 'Yat kiralama acenteleri, kaptanlar ve mavi tur operatörleri',
    ctaText: 'Yatçılık Paketini Seç',
    ctaAction: '/kayit',
    features: [
      { text: 'Lüks Yat Filosu Yönetim Sistemi (Kabin, Boy, Liman, Motor)', included: true, highlight: true },
      { text: 'Müşteri Rezervasyon & Fiyat Teklifi Talep Motoru', included: true, highlight: true },
      { text: 'İnteraktif Müsaitlik ve Doluluk Takvimi', included: true, highlight: true },
      { text: '3+ Ultra-Lüks Yatçılık ve Marina Teması', included: true },
      { text: '25 GB Yüksek Çözünürlüklü Yat Medya Depolama', included: true },
      { text: 'Çoklu Para Birimi (EUR, USD, TRY) Desteği', included: true },
      { text: 'WhatsApp Hızlı Teklif ve SMS Bildirim Entegrasyonu', included: true },
      { text: 'Özel Alan Adı, SSL ve 7/24 VIP Sunucu Hostingi', included: true },
      { text: 'Özel Müşteri Temsilcisi ve Telefon Desteği', included: true },
    ],
  },
  {
    id: 'enterprise-custom',
    name: 'Enterprise & Çoklu Şube',
    tagline: 'Büyük gruplar, zincir markalar ve ajanslar için özel çözümler.',
    monthlyPriceTRY: 7500,
    annualPriceTRY: 65000,
    targetAudience: 'Holdingler, franchise ağları ve dijital ajanslar',
    ctaText: 'Satış Ekibiyle Görüş',
    ctaAction: '/iletisim',
    features: [
      { text: 'Birden Fazla Web Sitesi (Multi-Tenant) Tek Panelden', included: true, highlight: true },
      { text: 'Özel Tasarım & Şablon Geliştirme Desteği', included: true },
      { text: 'Özel API ve CRM/ERP Entegrasyonları', included: true },
      { text: '100 GB+ Yüksek Performanslı Bulut Depolama', included: true },
      { text: '%99.99 Kesintisiz Hizmet Garantisi (SLA)', included: true },
      { text: 'Özel Güvenlik Duvarı (WAF) ve DDoS Koruması', included: true },
      { text: 'Aday Müşteri İçe/Dışa Aktarma (CSV/Excel)', included: true },
      { text: 'Size Özel Atanmış Teknik Proje Yöneticisi', included: true },
    ],
  },
];

export const PUBLIC_FAQS: FaqItem[] = [
  {
    id: 'faq-1',
    category: 'general',
    categoryTitle: 'Genel Bilgiler',
    question: 'Adiosoft geleneksel web tasarım süreçlerinden ve klasik platformlardan nasıl ayrışır?',
    answer: 'Geleneksel web siteleri oluşturucular genel amaçlıdır ve sektörünüze özel ihtiyaçlar için onlarca eklenti ve karmaşık yapılandırma gerektirir. Adiosoft ise doğrudan sektörünüze odaklanır; örneğin kurumsal siteler için hazır vaka çalışması ve teklif modülleri sunarken, yat kiralama için filo yönetimi, kabin filtreleri ve rezervasyon motorunu tek tıkla kullanıma hazır olarak sunar.',
  },
  {
    id: 'faq-2',
    category: 'general',
    categoryTitle: 'Genel Bilgiler',
    question: 'Web sitemi oluşturmak için kodlama veya tasarım bilgisine ihtiyacım var mı?',
    answer: 'Kesinlikle hayır! Adiosoft’un görsel sürükle-bırak editörü sayesinde metinleri tıklayıp düzenleyebilir, renkleri ve görselleri saniyeler içinde değiştirebilirsiniz. Tüm sektör şablonlarımız profesyonel tasarımcılar tarafından en yüksek tipografik ve görsel standartlarda önceden hazırlanmıştır.',
  },
  {
    id: 'faq-3',
    category: 'domains',
    categoryTitle: 'Alan Adı & Hosting',
    question: 'Kendi özel alan adımı (.com, .com.tr) bağlayabilir miyim?',
    answer: 'Evet! Mevcut alan adınızı yönlendirmek için panelimizden size verilen A ve CNAME kayıtlarını DNS sağlayıcınıza eklemeniz yeterlidir. Sistemimiz DNS kayıtlarınızı otomatik olarak doğrular ve ücretsiz 256-bit Let’s Encrypt SSL sertifikasını dakikalar içinde aktif eder.',
  },
  {
    id: 'faq-4',
    category: 'domains',
    categoryTitle: 'Alan Adı & Hosting',
    question: 'Hosting ve sunucu ücreti ayrıca ödemem gerekir mi?',
    answer: 'Hayır. Adiosoft bulut tabanlı bir SaaS platformudur. Yüksek hızlı Google Cloud ve global CDN hostingi, DDoS koruması, otomatik yedeklemeler ve SSL sertifikaları tüm abonelik paketlerimize fiyata dahil olarak sunulmaktadır.',
  },
  {
    id: 'faq-5',
    category: 'yacht',
    categoryTitle: 'Yat & Rezervasyon Modülü',
    question: 'Yat kiralama rezervasyon motoru nasıl çalışır?',
    answer: 'Yat filosu modülünden teknelerinizin fotoğraflarını, boy, kabin sayısı, liman ve günlük/haftalık fiyatlarını girersiniz. Web sitenizi ziyaret eden müşteriler istedikleri tarih aralığını ve misafir sayısını seçerek doğrudan rezervasyon talebinde bulunur. Talepler hem panelinize düşer hem de WhatsApp veya e-posta ile anında size bildirilir.',
  },
  {
    id: 'faq-6',
    category: 'pricing',
    categoryTitle: 'Fiyatlandırma & Ödeme',
    question: 'Ödemeleri nasıl yapabilirim ve taksit seçeneği var mı?',
    answer: 'Tüm ödemeler Türkiye’nin güvenilir ödeme altyapısı Shopier ve 3D Secure güvencesiyle kredi kartı veya banka kartı ile güvenle gerçekleştirilir. Yıllık planlarda tüm kredi kartlarına 12 aya varan taksit imkanı sunulmaktadır.',
  },
  {
    id: 'faq-7',
    category: 'pricing',
    categoryTitle: 'Fiyatlandırma & Ödeme',
    question: '3 günlük deneme süresinde kredi kartı bilgisi girmem gerekiyor mu?',
    answer: 'Hayır, 3 günlük ücretsiz deneme sürümünü başlatırken herhangi bir kredi kartı bilgisi vermeniz gerekmez. Sistemin tüm özelliklerini ve sektörel web sitesi oluşturmayı anında test edebilirsiniz.',
  },
  {
    id: 'faq-8',
    category: 'seo',
    categoryTitle: 'SEO & Performans',
    question: 'Web sitem Google aramalarında üst sıralara çıkar mı?',
    answer: 'Evet. Adiosoft altyapısı temiz semantik HTML5, otomatik sitemap.xml, robots.txt, OpenGraph etiketleri ve sayfa bazlı meta başlık/açıklama editörü ile donatılmıştır. Sunucularımız Google PageSpeed kriterlerine göre 95+ performans puanı verecek şekilde optimize edilmiştir.',
  },
  {
    id: 'faq-9',
    category: 'support',
    categoryTitle: 'Destek & Yardım',
    question: 'Teknik bir sorunla karşılaşırsam nasıl destek alabilirim?',
    answer: 'Panel içi canlı sohbet, e-posta destek merkezimiz ve telefonla VIP destek hattımız üzerinden uzman ekibimizle dilediğiniz zaman iletişime geçebilirsiniz. Destek taleplerine ortalama yanıt süremiz 15 dakikanın altındadır.',
  },
];

export const PUBLIC_TESTIMONIALS: Testimonial[] = [
  {
    id: 't-1',
    author: 'Kaptan Deniz Eren',
    role: 'Kurucu & Başkaptan',
    company: 'Aegean Azure Charters',
    sector: 'Lüks Yat Kiralama (Bodrum & Göcek)',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop',
    quote: 'Daha önce karmaşık ve sürekli bakım gerektiren harici eklentilerle uğraştığımız yat sitemizi Adiosoft’a taşıdık. Müşterilerimiz artık teknelerimizin kabinlerini ve tarihlerini görerek tek tıkla WhatsApp’tan rezervasyon talebi gönderiyor. İlk ayda %40 daha fazla rezervasyon aldık!',
    rating: 5,
    websiteUrl: 'aegeanazure.com',
  },
  {
    id: 't-2',
    author: 'Ahmet Yılmaz',
    role: 'Yönetici Ortak',
    company: 'Apex Global Strateji & Danışmanlık',
    sector: 'Kurumsal Yönetim Danışmanlığı',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop',
    quote: 'Ajanslara yüzbinlerce lira verip aylarca beklemek yerine, Adiosoft Kurumsal paketiyle şirketimizin web sitesini 2 gün içinde yayına aldık. Tasarımın şıklığı ve hızından tüm yönetim kurulumuz büyülendi.',
    rating: 5,
    websiteUrl: 'apexglobal.com.tr',
  },
  {
    id: 't-3',
    author: 'Av. Elif Karadağ',
    role: 'Kurucu Avukat',
    company: 'Karadağ Hukuk & Arabuluculuk',
    sector: 'Hukuk & Ticaret Hukuku',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop',
    quote: 'Hukuk büroları için güven veren bir duruş sergilemek hayati önem taşır. Justicia şablonu sayesinde makalelerimizi ve uzmanlıklarımızı kurumsal bir saygınlıkla yayınlayabiliyoruz. SEO uyumu sayesinde Google’dan doğrudan müvekkil kazanıyoruz.',
    rating: 5,
    websiteUrl: 'karadaghukuk.av.tr',
  },
  {
    id: 't-4',
    author: 'Dr. Kerem Aksoy',
    role: 'Medikal Direktör',
    company: 'SanaVita Dental & Aesthetic',
    sector: 'Sağlık & Estetik',
    avatar: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=200&auto=format&fit=crop',
    quote: 'Hastalarımızın online randevu alabilmesi ve tedavileri detaylı inceleyebilmesi kliniğimizin doluluk oranını katladı. Mobil uyumu o kadar akıcı ki hastalarımızın %85’i telefonlarından randevu oluşturuyor.',
    rating: 5,
    websiteUrl: 'sanavitaklinik.com',
  },
];

export const PLATFORM_STATS = [
  { value: '4.800+', label: 'Aktif Profesyonel Site', change: '+32% bu ay' },
  { value: '120.000+', label: 'Aylık Toplanan Teklif & Talep', change: 'Gerçek dönüşüm' },
  { value: '99.98%', label: 'Kesintisiz Çalışma Süresi (Uptime)', change: 'Google Cloud altyapısı' },
  { value: '< 450 ms', label: 'Ortalama Sayfa Açılış Hızı', change: 'A+ Google PageSpeed' },
];

export const TRUSTED_BRANDS = [
  'Apex Holding',
  'Aegean Azure Charters',
  'Justicia Legal Group',
  'SanaVita Clinics',
  'ArchForm Studio',
  'Bosphorus Marine VIP',
  'Vanguard Capital',
  'Riviera Yachting',
];
